<template>
  <div id="csvexport">
    <v-container fluid grid-list-lg>
      <v-flex justify-center xs12 sm12 md12>
        <v-card color="green lighten-1">
          <v-btn @click="csvExport">Export</v-btn>
          <div ref="table"></div>
        </v-card>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import db from "./firebaseinit";
import firebase from 'firebase';
import { mapState, mapMutations } from 'vuex'
var Tabulator = require("tabulator-tables"); //import Tabulator library


export default {
  name: "dashboard",
  data() {
    return {
      search: "",
      dialog: false,
      inventory: [],
      did: null,
      users: [],
      Admin: false,
      Standard: false,
      tabulator: null, //variable to hold your table
      exporting: false,
      tableData: [
      ], //data for table to display
    };
  },
  watch:{
    //update table if data changes
    tableData:{
      handler: function (newData) {
        this.tabulator.replaceData(newData);
      },
      deep: true,
    }
  },
  created() {
    var that = this
    db.collection("inventory")
      .orderBy("company")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'company': doc.data().company,
            'devicetype': doc.data().devicetype,
            'did': doc.data().did,
            'tempdid': doc.data().tempdid,
            'e911': doc.data().e911,
            'e911address': doc.data().e911address,
            'extension': doc.data().extension,
            'notes': doc.data().notes,
            'user': doc.data().user
          };
          this.inventory.push(data);
          this.tableData.push(data);
        });
      });
      if(firebase.auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser.email;
      //Gets User Group//
      console.log(this.currentUser)
      console.log(this.users)
      var user = this.currentUser
      var a = this.users.indexOf(user)
      console.log(a)
      };
      var users = db.collection("users")
      .orderBy("user")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'user': doc.data().user,
            'admin': doc.data().admin,
            'standard': doc.data().standard
          };
          this.users.push(data);
        });
      });
     var query = firebase.firestore().collection('users')
      .where("user", '==', this.currentUser)
      .get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
        console.log(doc.data())
        this.admin = doc.data().admin
        this.standard = doc.data().standard
        this.permissions = true
        })
        console.log("Admin: " + this.admin)
        console.log("Standard: " + this.standard)
        console.log(this.currentUser)
      });
  },
  methods: {
  csvExport() {
    this.tabulator.download("csv", "data.csv")
    },
  },
  mounted(){
    //instantiate Tabulator when element is mounted
    this.tabulator = new Tabulator(this.$refs.table, {
      data: this.tableData, //link data to table
      height:"550px",
      layout:"fitColumns",
      columns: [
        {title:"Company", field:"company"},
        {title:"Device Type", field:"devicetype", sorter:"number"},
        {title:"DID", field:"did"},
        {title:"Temp DID", field:"tempdid"},
        {title:"E911", field:"e911", formatter:"tickCross"},
        {title:"E911 Address", field:"e911address", align:"center"},
        {title:"Extension", field:"extension"},
        {title:"Notes", field:"notes"},
        {title:"User", field:"user"},
      ], //define table columns
    });
  },

  template: '<div ref="table"></div>', //create table holder element
  ...mapMutations(['permissions', 'admin', 'standard'])

};
</script>



// WEBPACK FOOTER //
// src/components/CSVExport.vue